import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import image from "../imgs/imageplaceholder.svg";
import camera from "../imgs/camera.svg";
import copy from "../imgs/copy.svg";

function Profile() {
  const [page, setPage] = useState("dashboard");
  return (
    <div className="flex">
      <Sidebar page={page} />
      <div className=" w-full ml-[304px]">
        <Navbar />
        <div className="px-8 flex gap-8">
          <div className="flex flex-col gap-4 w-[416px]">
            <div className="flex flex-col gap-4 items-center justify-center rounded-3xl border border-[#D7E1F4] p-6 w-full">
              <img src={image} alt="" className="rounded-full" />
              <div className="flex items-center gap-2">
                <img src={camera} alt="" />{" "}
                <p className="text-[#4169E1] text-[16px] leading-4 hover:text-[#000080] active:opacity-85 tracking-[2%]">
                  Upload Image
                </p>
              </div>
            </div>
            <div className="p-6 rounded-3xl border border-[#D7E1F4] flex-col flex gap-4 text-[#4C689E] text-[16px] leading-[19.36px]">
              <div className="flex justify-between items-center">
                <p>Name</p>
                <p className="font-semibold">Lawal Wahab Babatunde</p>
              </div>
              <div className="flex justify-between items-center">
                <p>Email</p>
                <p className="font-semibold">wabdotmail@gmail.com</p>
              </div>
              <div className="flex justify-between items-center">
                <p>Phone Number</p>
                <p className="font-semibold">0906 856 2949</p>
              </div>
              <div className="flex justify-between items-center">
                <p>Account Status</p>
                <p className="font-semibold text-[#2DAE32]">Active</p>
              </div>
              <div className="flex justify-between ">
                <p>Referral link</p>
                <div className="flex flex-col gap-2 items-end">
                  <p className="font-semibold">www.subsum.com/tre/wd...</p>
                  <div className="flex gap-1 items-center">
                    <img src={copy} alt="" />{" "}
                    <p className="cursor-default text-[#4169E1] font-semibold text-[16px] leading-4 tracking-[2%] hover:text-[#000080] active:opacity-85">
                      Copy
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <p className="text-[#4169E1] font-semibold  hover:text-[#000080] active:opacity-85">
                  Edit Details
                </p>
              </div>
            </div>
          </div>
          <div className="w-[432px]">
            <div className=" p-2 flex gap-2 border rounded-[100px] border-[#D7E1F4]">
              <div className="bg-[#EFF5FB] flex items-center rounded-[100px] w-[204px] h-[40px] justify-center ">
                <p className="text-[#3C517C] font-semibold leading-[16.94px] text-[14px]">
                  Change Password
                </p>
              </div>
              <div className="border border-[#EFF5FB] flex items-center rounded-[100px] w-[204px] h-[40px] justify-center ">
                <p className="text-[#A9BADA] font-semibold leading-[16.94px] text-[14px]">
                  Change PIN
                </p>
              </div>
            </div>
            <div className="mt-[11px] rounded-3xl border border-[#D7E1F4] p-6">
              <form className="flex flex-col gap-4">
                <div className=" flex flex-col gap-1">
                  <label className="text-[#4C689E]">Current Password</label>
                  <input
                    type="text"
                    className="p-2 border border-[#D7E1F4] rounded py-[15.5px] text-[16px] leading-[19.36px] bg-inherit outline-none"
                    placeholder="Enter Current Password"
                  />
                </div>
                <div className=" flex flex-col gap-1">
                  <label className="text-[#4C689E]">New Password</label>
                  <input
                    type="password"
                    className="p-2 border border-[#D7E1F4] rounded py-[15.5px] text-[16px] leading-[19.36px] bg-inherit outline-none"
                    placeholder="Enter New Password"
                  />
                </div>
                <div className=" flex flex-col gap-1">
                  <label className="text-[#4C689E]">Confirm New Password</label>
                  <input
                    type="password"
                    className="p-2 border border-[#D7E1F4] rounded py-[15.5px] text-[16px] leading-[19.36px] bg-inherit outline-none"
                    placeholder="Enter New Password"
                  />
                </div>
                <button className="mt-4 py-[17px] w-full text-[#ffffff] bg-[#4169E1] rounded-[10px] opacity-50 ">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
